import { FC } from "react";

interface ICustomIcon {
  fileName: string;
  className?: string;
}

const CustomIcon: FC<ICustomIcon> = ({ fileName, className }) => {
  const getIconPath = (name: string) => `/icons/${encodeURIComponent(name)}.svg#${encodeURIComponent(name)}`;

  return (
    <svg width="100%" height="100%" className={className}>
      <use xlinkHref={getIconPath(fileName)} width="100%" height="100%" />
    </svg>
  );
};

export default CustomIcon;
